<template>
    <form
        @submit.prevent="deleteUser"
        :action="url"
        method="post"
        class="flex justify-between items-center space-x-4 card"
    >
        <h2 class="heading-2">Delete User</h2>

        <loading-button
            :loading="form.processing"
            type="submit"
            class="btn btn-green"
        >
            Delete
        </loading-button>
    </form>
</template>

<script setup>
import useForm from '@/functions/useForm'

const props = defineProps({
    url: {
        type: String,
        required: true,
    }
})

const form = useForm()

const deleteUser = () => {
    if(confirm('Are you sure you want to delete your account?')) {
        form.delete(props.url)
    }
}
</script>
